import React, { type ReactNode } from 'react';
import type { GestureResponderEvent, ViewStyle } from 'react-native';

import { Button } from '@/components/ui';
import { createStyles } from '@/hooks';
import { guardianColors } from '@/theme/colors';

type AuthPrimaryButtonProps = {
  onPress: (event: GestureResponderEvent) => void;
  children: ReactNode;
  /** Extra style (e.g. `marginTop`) merged onto the button container. */
  style?: ViewStyle;
};

/** Full-width filled primary action button used across the auth flow. */
export function AuthPrimaryButton({ onPress, children, style }: AuthPrimaryButtonProps) {
  const styles = useStyles();
  return (
    <Button onPress={onPress} style={style ? [styles.button, style] : styles.button}>
      <Button.Text variant="Font Guardian App/Subtitle/Subtitle 14 Semibold">
        {children}
      </Button.Text>
    </Button>
  );
}

const useStyles = createStyles(({ scale }) => ({
  button: {
    width: '100%',
    borderRadius: scale(8),
    backgroundColor: guardianColors['Main/Main'],
  },
}));

export default AuthPrimaryButton;
